// Keys used by useShowOneTime to track one-time UI events (tooltips, banners, sheets).
// These are also excluded from AsyncStorage clearing on logout
export const ONE_TIME_SHOW_KEYS = [
    'SBK_EventDetailScreen_GameTrackerTooltip',
    'SBK_BetDetailScreen_GameTrackerTooltip',
    'SBK_DEVScreen_GameTrackerTooltip',
    'Picks_EntryScreen_GameTrackerTooltip',
    'RaceToPlace_InfoSheet',
    'SocialFeed_EditUsernameAvatarBanner',
    'Pickem_FeedTab_FeatureTooltip',
    'Pickem_Lobby_PickTypeBadgesEducation',
    'Pickem_SearchTab_FeatureTooltip',
] as const;
